import('./base-integration');
import {homeShell} from '@edreamsodigeo/frontend-shell';

export function execute(cb) {
    return homeShell.execute(cb);
}
